import React, { useState } from 'react';

import { FilterIcon } from '../../../icons'

import {
    Box,
    Drawer,
    Button,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
    InputLabel,
    Avatar,
    Tooltip,
    Switch,
    FormControlLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import FilterListIcon from '@mui/icons-material/FilterList';


import SingleSelectDroupdown from '../../../components/Projects/project-components/SingleSelectDroupdown';
import TeamSelectDroupDown from '../../../components/Projects/project-components/TeamSelectDroupDown';

import MultiClientSelect from '../../../components/DemoTabs/MultiClientSelect';

import ClientImageSelect from '../../../components/DemoTabs/ClientImageSelect';
import ActivityLevel from '../../../components/DemoTabs/ActivityLevel';
import SelectDropDowns from '../../../components/DemoTabs/SelectDropDowns';

import { FilterwIcon } from '../../../icons';



const WorkSessionsFilter = () => {
    const [billable, setBillable] = useState(true);
    const [disableActivity, setDisableActivity] = useState(false);

    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 



    // Project Seclect Single 
    const [selectedTeamsAll, setSelectedTeamsAll] = useState(null);
    // Project Seclect Single 


    // start Projects 
    const [selectedClients, setSelectedClients] = React.useState([]);
    const allClients = [
        { name: 'Client Name 1', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Client Name 2', image: null },
        { name: 'Client Name 3', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Client Name 4', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Client Name 5', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Client Name 6', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];
    // End Projects 

    // start Members 

    const [selectedUsers, setSelectedUsers] = useState([]);

    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];


    // start activity level 
    const [selectedActivityLevel, setSelectedActivityLevel] = useState('');

    const ActivityLevelData = [
        { name: '95 %', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: '90 %', image: null },
        { name: '85 %', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: '80 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '75 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '70 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: '60 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    ];
    // End activity level 

    // start Time worked 
    const [selectedTimeWorked, setSelectedTimeWorked] = useState('');

    const TimeWorkedData = [
        { name: 'Select' },
        { name: 'With time tracked' },
        { name: 'With no time tracked' },
    ];

    // End  Time worked 



    // export default function FilterPopup() {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerContent = (
        <Box sx={{ width: isMobile ? '100vw' : 360, height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fff', borderRadius: isMobile ? 0 : '0 0 0 0' }} role="presentation">
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center"
                sx={{ p: '24px', borderBottom: '1px solid #D0D4E4', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                <Typography fontSize={'22px'} fontWeight={700} sx={{ fontFamily: 'Manrope' }}>Filter</Typography>
                <IconButton onClick={toggleDrawer(false)} sx={{ p: 0 }}>
                    <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                </IconButton>
                <Box onClick={toggleDrawer(false)}
                    style={{
                        position: 'absolute', backgroundColor: '#fff', borderRadius: '100px', boxShadow: '0px 1px 6px 2px #00000030', height: '32px',
                        width: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', left: '-12px', bottom: '-16px', cursor: 'pointer',
                        zIndex: 10,
                    }}>
                    <ChevronRightIcon fontSize="small" />
                </Box>
            </Box>

            {/* Body */}
            <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 3 }}>
                {/* <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Client</InputLabel>
                    <ClientImageSelect label="All Clients" options={allClients} selectedValues={selectedClients} onChange={setSelectedClients} />
                </Box> */}
                {/* start Teams sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Client</InputLabel>
                    <TeamSelectDroupDown
                        selectedTeamsAll={selectedTeamsAll}
                        setSelectedTeamsAll={setSelectedTeamsAll}
                    />
                </Box>
                {/* End Teams sec  */}

                {/* start Projects sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Projects</InputLabel>
                    <SingleSelectDroupdown
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                    />


                </Box>
                {/* End Projects sec  */}

                {/* start Members sec  */}

                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Members</InputLabel>
                    <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                </Box>


                {/* End Members sec  */}

                {/* start Activity Level */}
                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Activity Level</InputLabel>
                    <ActivityLevel label="All levels" options={ActivityLevelData} selectedValue={selectedActivityLevel} onChange={setSelectedActivityLevel} />
                </Box>

                {/* End Activity Level */}



                {/* start Time Worked */}
                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Time Worked</InputLabel>
                    <SelectDropDowns label="With time tracked" options={TimeWorkedData} selectedValue={selectedTimeWorked} onChange={setSelectedTimeWorked} />
                </Box>

                {/* End Time Worked */}
                <Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                        <Typography className="" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }}>Include archived projects</Typography>
                        <FormControlLabel control={
                            <Switch
                                checked={billable}
                                onChange={() => setBillable(!billable)}
                                color="primary"
                                sx={{
                                    width: 40,
                                    height: 25,
                                    padding: 0,
                                    '& .MuiSwitch-switchBase': {
                                        padding: 0.5,
                                        '&.Mui-checked': {
                                            transform: 'translateX(16px)',
                                            color: '#fff',
                                            '& + .MuiSwitch-track': {
                                                backgroundColor: '#E0EEFE',
                                                opacity: 1,
                                                border: '1px solid #0076FE1F',

                                            },
                                            '& .MuiSwitch-thumb': {
                                                backgroundColor: '#0076FE',
                                            }
                                        },
                                    },
                                    '& .MuiSwitch-thumb': {
                                        width: 13,
                                        height: 13,
                                        boxShadow: ' 0 1px 1px #00000040',
                                        margin: '2px auto 0',
                                    },
                                    '& .MuiSwitch-track': {
                                        borderRadius: '20px',
                                        backgroundColor: '#E5E8EB',
                                        opacity: 1,
                                        border: '1px solid #D0D5DD',
                                    },
                                }}
                            />
                        }
                        />
                    </Box>
                </Box>






            </Box>

            {/* Footer */}
            <Box
                sx={{
                    p: isMobile ? 2 : '24px 30px',
                    borderTop: '1px solid #DFDFDF',
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 2,
                    justifyContent: 'center',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1
                }}
            >
                <Button onClick={toggleDrawer(false)} variant="outlined" fullWidth={isMobile}
                    sx={{ backgroundColor: '#fff', textTransform: 'capitalize', color: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: 500, height: '50px', border: '1px solid #9095A1', borderRadius: '8px', fontFamily: 'Manrope' }}>
                    Clear Filters
                </Button>
            </Box>
        </Box>
    );

    return (
        <>
            {/* <Tooltip title="Filter" arrow placement='top'>
                <Button onClick={toggleDrawer(true)} sx={{
                    background: '#fff',
                    borderRadius: '50px',
                    color: '#1A1F36',
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    width: '40px',
                    height: '38px',
                    border: '1px solid #E5E8EB',
                    '&:hover': {
                        background: '#f5f5f5'
                    }
                }}><FilterIcon /></Button>
            </Tooltip> */}

            <Button onClick={toggleDrawer(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none', }}
                tabIndex={-1} startIcon={<FilterwIcon />}>
                Filter
            </Button>
            <div>
                <Drawer
                    anchor="right"
                    open={open}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                        sx: {
                            width: isMobile ? '100vw' : 360,
                            borderRadius: isMobile ? 0 : '0 0 0 0',
                            overflow: 'visible',
                        }
                    }}
                >
                    {DrawerContent}
                </Drawer>
            </div>
        </>
    );
}

export default WorkSessionsFilter;
